import { GOLD_RATE_SOURCE } from './financeCostConstants';

export function toFiniteNumber(value) {
  if (value == null || value === '') return 0;
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  const n = parseFloat(String(value).trim().replace(/\s/g, '').replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
}

export function findPriceItem(prices, code) {
  if (!prices || !Array.isArray(prices)) return null;
  const needle = String(code || '').toUpperCase();
  return prices.find((item) => String(item?.currencyCode || '').toUpperCase() === needle) || null;
}

/** Canlı has alış / satış — POS ile aynı kaynak: ALTINTRY. */
export function getLiveHasRates(prices) {
  const altin = findPriceItem(prices, 'ALTINTRY') || findPriceItem(prices, 'HASALTIN');
  return {
    buy: toFiniteNumber(altin?.buy),
    sell: toFiniteNumber(altin?.sell)
  };
}

export function resolveGoldRate({ source, rule, product, rateContext } = {}) {
  // Varsayilan: has SATIS (ayarlarda secilirse rule/settings onu ezer)
  const src = source || rule?.goldRateSource || rateContext?.defaultGoldRateSource || GOLD_RATE_SOURCE.LIVE_SELL;
  const live = rateContext?.liveHas || getLiveHasRates(rateContext?.prices);

  if (src === GOLD_RATE_SOURCE.LIVE_BUY) {
    return { source: src, rate: toFiniteNumber(live.buy), ok: toFiniteNumber(live.buy) > 0 };
  }
  if (src === GOLD_RATE_SOURCE.LIVE_SELL) {
    return { source: src, rate: toFiniteNumber(live.sell), ok: toFiniteNumber(live.sell) > 0 };
  }
  if (src === GOLD_RATE_SOURCE.PRODUCT) {
    const rate = toFiniteNumber(product?.hasAltinKuru);
    return { source: src, rate, ok: rate > 0 };
  }
  if (src === GOLD_RATE_SOURCE.MANUAL) {
    const rate = toFiniteNumber(rule?.manualGoldRate);
    return { source: src, rate, ok: rate > 0 };
  }
  return { source: src || null, rate: 0, ok: false };
}
